import Grid from '@mui/material/Grid';
import BaseTable from 'components/Tables/BaseTable';
import { actions } from 'ducks/users';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreData } from 'selectors/generic';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/userManagement';
import { currentUser } from 'selectors/currentUser';

const Component = props => {
  const { user, users } = props;
  const { create, fetchAll, remove, update } = props;

  return (
    <Grid size={12}>
      <BaseTable
        columns={columns(user)}
        data={users}
        options={{
          showTitle: false,
          searchFieldAlignment: 'left',
          pageSize: 10,
          maxBodyHeight: null,
          minBodyHeight: null,

          actionsCellStyle: {
            minWidth: 150,
            paddingLeft: 20
          }
        }}
        actions={[
          {
            icon: tableIcons.Password,
            tooltip: 'Change password',
            onClick: (event, rowData) => alert('Talk to ReachOk administrator please!')
          }
        ]}
        editable={{
          onRowAdd: (newData, oldData) => {
            newData.active = JSON.parse(newData.active);
            return create(newData);
          },
          onRowUpdate: (newData, oldData) => {
            newData.active = JSON.parse(newData.active);
            // Only what changed. This started from the whole row and then put
            // the changed fields back on top of it, so it always sent
            // everything - administrator included, which the API refuses.
            // `tableData` is material-table's own bookkeeping and is not a field.
            const data = Object.keys(newData)
              .filter(k => k !== 'tableData' && newData[k] !== oldData[k])
              .reduce((acc, k) => ({ ...acc, [k]: newData[k] }), {});
            return update(newData.id, data).then(() => fetchAll());
          },
          onRowDelete: oldData => remove(oldData.id)
        }}
      />
    </Grid>
  );
};

const makeMapStateToProps = () => {
  const users = getImmutableStoreData('users');
  const mapStateToProps = (state, props) => ({
    // Superusers are in the collection now - the API says what exists - and
    // this screen is what does not show them. It cannot: `_refuse` forbids
    // editing a superuser through /users/<id>, so listing them here would be an
    // editable table making a promise it cannot keep for those rows.
    users: users(state).filter(u => !u.superuser),
    user: currentUser(state)
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  fetchAll: () => dispatch(actions.fetchAll()),
  create: data => dispatch(actions.createPromise(data)),
  remove: id => dispatch(actions.removePromise(id)),
  update: (id, data) => dispatch(actions.updatePromise(id, data))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
